import React from 'react';

export default ({ className }) => (
  <svg className={className} xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16">
    <g transform="translate(0 1)">
      <polygon points="10 12.999 10 10.009 11 10.009 11 14 0 14 0 0 11 0 11 3.999 10 3.999 10 1.001 1 1.001 1 12.999"/>
      <polygon points="4.5 9 4.5 8 11 8 11 9"/>
      <polygon points="13 8.5 16 5.5 13 2.5"/>
      <polygon points="5.5 5.5 5.5 11.5 2.5 8.5"/>
      <polygon points="7 6 7 5 13.5 5 13.5 6"/>
    </g>
  </svg>
);
